import React, {Component, ReactNode} from 'react';
import {inject, observer} from 'mobx-react';
import SmartLabelTooltip from 'app/components/reusable/SmartLabelTooltip';
import SmartSelect from 'app/components/reusable/SmartSelect';
import {IncubatorCreateLineController} from 'app/controllers/IncubatorCreateLineController';
import {ElementWithError} from 'app/components/reusable/ElementWithError';

const MATCH_FORMATS = [
    'bo1',
    'bo2',
    'bo3',
    'bo5',
    'bo7',
    'bo9'
];

interface Props {
    controller?: IncubatorCreateLineController;
}

@inject('controller')
@observer
export default class IncubatorLineMatchFormat extends Component<Props> {
    get controller(): IncubatorCreateLineController {
        return this.props.controller;
    }

    get matchFormat(): string {
        return this.controller.incubatorGame?.attributes?.match_format ?? '';
    }

    handleSelectMatchFormat = (newValue: string): void => {
        this.controller.onSelectMatchFormat(newValue);
        this.controller.incubatorGame.clearError('match_format');
    };

    errorHint = (field: string): ReactNode => this.error(field);

    error = (field: string): string => this.controller.incubatorGame.getError(field);

    render(): React.ReactNode {
        return <div className="field-item match-format">
            <SmartLabelTooltip
                labelTooltip="title_incubator_match_format"
                descriptionTooltip="tooltip_incubator_match_format"
            />
            <ElementWithError
                errorHint={this.errorHint('match_format')}
                className={this.error('match_format') ? 'field-error' : ''}
            >
                <div className="classical-select" id="select_match_format">
                    <SmartSelect
                        key="incubator_match_format"
                        collection={MATCH_FORMATS.map(format => ({
                            text: format.toUpperCase(),
                            text2: '',
                            value: format
                        }))}
                        onChange={this.handleSelectMatchFormat}
                        value={this.matchFormat}
                        id="line_match_format"
                    />
                </div>
            </ElementWithError>
        </div>;
    }
}

